import { WorkspaceElement } from 'types';

export const workspaceElement: WorkspaceElement = {
  id: '',
  elementId: '',
  position: { x: 0, y: -500 },
};
